module.exports = __webpack_public_path__ + "img/go.ccad859c.png";